<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>基础信息</h3>
                <p></p>
            </div>
            <div class="info-main">      
                <div class="input-box">
                    <p><span>*</span>立项年度：</p>
                    <a-date-picker
                        class="input"
                        mode="year"
                        format='YYYY年'
                        :disabled="type=='look'"
                        v-model="info.decideDate" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        @panelChange="panelChangeOne"/>
                </div>
                <div class="input-box">
                    <p><span>*</span>项目类别：</p>
                    <a-select 
                        class="input" 
                        allowClear 
                        show-search 
                        @search="handSearch"
                        :filter-option="filterOption"
                        v-model="info.consProjectTypeCode"
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in xmlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程名称：</p>
                    <a-select
                        autoClearSearchValue
                        mode="tags"
                        class="input" 
                        allowClear 
                        v-model="info.courseName" 
                        :disabled="type=='look'" 
                        :filter-option="filterOption" 
                        show-search
                         @change="kcChange">
                        <a-select-option v-for="(item,index) in kcArr" :key="index" :value="item.courseName">{{item.courseName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程号：</p>
                    <a-input class="input" :disabled="type=='look'" v-model="info.courseNo" />
                </div>
                <div class="input-box">
                    <p>课程属性：</p>
                    <a-select class="input" allowClear v-model="info.courseAttrCode" :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in kcsxArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程主管：</p>
                    <a-select
                        mode="tags"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.courseDirectorNo"
                        @change="teacherChange"
                        option-label-prop="label"
                        :disabled="type=='look'">
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherId" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>项目经费：</p>
                    <a-input class="input" :disabled="type=='look'" v-model="info.amount" />
                </div>
                <div class="input-box input-box-big">
                    <p>备注：</p>
                    <a-textarea class="input" :rows="4" :disabled="type=='look'" v-model="info.remark" />
                </div>
            </div>
        </div>
        <div class="info-box">
            <div class="info-title">
                <h3>立项通知截图</h3>
                <p></p>
            </div>
            <a-upload-dragger
                class="upload-box"
                name="file"
                list-type="picture-card"
                :multiple="true"
                :action="$store.state.axiosUrl+'/api-f/files'"
                :headers="headers"
                @change="fileChange"
                :file-list="fileList"
                :disabled="type=='look'"
            >
                <p class="ant-upload-drag-icon">
                    <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">点击或拖拽文件上传</p>
                <p class="ant-upload-hint">支持单次或批量上传</p>
            </a-upload-dragger>
        </div>
        <div class="btn-box">
            <a-button type="primary" v-if="type!='look'" @click="sub">提交</a-button>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/undergraduate/culture/build'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { list } from '@/baseAPI/undergraduate/culture/courseMould'
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                fileList:[],
                visible:false,
                id:'',
                info:{
                    decideDate:null,
                    consProjectTypeCode:null,
                    projectLevelCode:null,
                    courseNo:null,
                    // courseName:null,
                    courseAttrCode:null,
                    // courseDirectorNo:null,
                    courseDirectorName:null,
                    files:null,
                    remark:null,
                    amount:null,
                    fileList:[],
                },
                xmlbArr:[],
                xmjbArr:[],
                kcsxArr:[],
                jsArr:[],
                yearShowOne:false,
                year:null,
                kcArr:[],
            }
        },
        mounted () {
            this.type=this.$route.query.type;
            list().then(res=>{
                this.kcArr=res.data;
            })
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })
            getDicts({dataCode:'KCJSXMLB',status:true}).then(res=>{
                this.xmlbArr=res.data.dicts;
                this.info.consProjectTypeCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'XMJB',status:true}).then(res=>{
                this.xmjbArr=res.data.dicts;
                this.info.projectLevelCode=res.data.defaultValue[0]
            })
            getDicts({dataCode:'KCSX',status:true}).then(res=>{
                this.kcsxArr=res.data.dicts;
                this.info.courseAttrCode=res.data.defaultValue[0]
            })
            if(this.type!='add'){
                info(this.$route.query.id).then(res=>{
                    this.info=res.data;
                    this.info.fileList=[];
                    if(res.data.files!=''&&res.data.files!=null){
                        this.info.fileList=res.data.files.split(",;");
                    }
                    this.fileList=[];
                    for(let i=0;i<this.info.fileList.length;i++){
                        this.fileList.push({
                            uid: i,
                            name: this.info.fileList[i]+i,
                            status: 'done',
                            url: this.$store.state.axiosUrl+this.info.fileList[i],
                        })
                    }

                })
            }
        },
        methods:{
            handSearch(value){
                if(value!=''){
                    this.info.consProjectTypeCode=value
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['decideDate','consProjectTypeCode']
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                this.info.files=this.info.fileList.join(',;')
                if(isSub){
                    if(this.info.courseName !=null && this.info.courseName.constructor==Array && this.info.courseName.length >= 1){
                        this.info.courseName = this.info.courseName[0]
                    }
                    if(this.info.courseDirectorNo !=null && this.info.courseDirectorNo.constructor==Array && this.info.courseDirectorNo.length >= 1){
                        this.info.courseDirectorNo = this.info.courseDirectorNo[0]
                    }
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增课程建设项目成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改课程建设项目成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherChange(value){
                value = value[0]
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherId==value){
                        this.info.courseDirectorName=this.jsArr[i].teacherName
                    }
                }
                if(this.info.courseDirectorName == null || this.info.courseDirectorName==''){
                    this.info.courseDirectorName = value
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.info.decideDate = this.getTimeStr(value._d,'yyyy');
                this.yearShowOne = false;
            },
            kcChange(value){
                for(let i=0;i<this.kcArr.length;i++){
                    if(this.kcArr[i].courseName==value){
                        console.log(this.kcArr[i].courseCode)
                        this.info.courseNo=this.kcArr[i].courseCode
                    }
                }
            },
            fileChange(file){
                if(typeof file.file.response!='undefined'){
                    var res=file.file.response;
                    this.$notification['success']({
                        message: '成功',
                        description:'文件上传成功'
                    });
                    this.info.fileList.push(res.url)
                }else if(file.file.status=='removed'){
                    var num=this.fileList.indexOf(file.file);
                    this.info.fileList.splice(num, 1)
                }
                this.fileList=file.fileList;
            },

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
    }
    .info-main .input-box-center{
        width: 66%;
    }
    .info-main .input-box-half{
        width: 49.5%;
    }
    .info-main .input-box-big{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box p span{
        color: #ff0000;
        margin-right: 5px;
    }
    .info-main .input-box .input{
        width: calc(100% - 12rem);
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .upload-box{
        margin-top: 2rem;
        display: block;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled,.ant-calendar-picker >>> .ant-input[disabled]{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .upload-box >>> .ant-upload-list:after{
      content: ".";
      display: block;
      font-size: 0;
      height: 0;
      clear: both;
    }
    .upload-box >>> .ant-upload.ant-upload-disabled{
        display: none;
    }
    .reject-btn{
        background-color: #ffa500;
        border-color: #ffa500;
    }
</style>
